// import React from 'react';
import { useEffect } from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';

// Import the page components
import WritingPage from './components/WritingPage';
import EnergyPage from './components/EnergyPage';
import ThinkingPage from './components/ThinkingPage';
import ProjectDetailPage from './components/ProjectDetailPage';

function App() {
  useEffect(() => {
    document.title = 'Llewellyn Portfolio';
  }, []);

  return (
    <div className="app-container">
      <nav>
        <ul>
          <li>
            <NavLink
              to="/writing"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Writing
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/energy"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Energy
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/thinking"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Tools
            </NavLink>
          </li>
        </ul>
      </nav>

      <Routes>
        <Route path="/" element={<div style={{ marginTop: '20px' }}>Please select a category above.</div>} />
        <Route path="/writing" element={<WritingPage />} />
        <Route path="/energy" element={<EnergyPage />} />
        <Route path="/thinking" element={<ThinkingPage />} />
        <Route path="/project/:projectId" element={<ProjectDetailPage />} />
      </Routes>
      </div>
  );
}

export default App;
